import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { buttonNames } from '../../constants';
import DashboardPanel from '../../containers/DashboardPanel';
import CoursesPanel from '../../containers/CoursesPanel';
import PersonnelPanel from '../../containers/PersonnelPanel';
import EventsPanel from '../../containers/EventsPanel';
import InductionsPanel from '../../containers/InductionsPanel';
import AccidentsPanel from '../../containers/AccidentsPanel';
import MeetingsPanel from '../../containers/MeetingsPanel';
import UserPannel from '../../containers/UserPannel';
import HazardsPanel from '../../containers/HazardsPanel';
import DocumentLibraryPanel from '../../containers/DocumentLibraryPanel';
import DocumentLibraryPanelForBranch from '../../containers/DocumentLibraryPanelForBranch';

const useStyles = makeStyles((theme) => ({
  viewPanelContainer: {
    marginTop: 45,
    marginLeft: 370,
    marginRight: 50
  },
  noPermissionHeader: {
    marginTop: 60
  }
}));

const BranchesViewPanel = (props) => {
  const classes = useStyles();
  const { currentBranchesRecord, loggedInUser, currentBranch } = props;
  let currentPanelToShow;

  const denyAccess =
    currentBranch != null &&
    ((loggedInUser.companyId != null &&
      currentBranch.companyId !== loggedInUser.companyId) ||
      (loggedInUser.branchId != null &&
        currentBranch.id !== loggedInUser.branchId));

  switch (currentBranchesRecord) {
    case buttonNames.DASHBOARD:
      currentPanelToShow = <DashboardPanel />;
      break;
    case buttonNames.COURSES:
      currentPanelToShow = <CoursesPanel />;
      break;
    case buttonNames.PERSONNEL:
      currentPanelToShow = <PersonnelPanel />;
      break;
    case buttonNames.EVENTS:
      currentPanelToShow = <EventsPanel />;
      break;
    case buttonNames.INDUCTIONS:
      currentPanelToShow = <InductionsPanel />;
      break;
    case buttonNames.ACCIDENTS:
      currentPanelToShow = <AccidentsPanel />;
      break;
    case buttonNames.MEETINGS:
      currentPanelToShow = <MeetingsPanel />;
      break;
    case buttonNames.USERS:
      currentPanelToShow = <UserPannel />;
      break;
    case buttonNames.HAZARDS:
      currentPanelToShow = <HazardsPanel />;
      break;
    case buttonNames.DOCUMENT_LIBRARY:
      currentPanelToShow = <DocumentLibraryPanel />;
      break;
    case buttonNames.DOCUMENT_LIBRARY_FOR_BRANCH:
      currentPanelToShow = <DocumentLibraryPanelForBranch />;
      break;
    default:
      currentPanelToShow = <CoursesPanel />;
      break;
  }

  console.log(currentPanelToShow);

  return (
    <div className={classes.viewPanelContainer}>
      {denyAccess ? (
        <h2 className={classes.noPermissionHeader}>
          You do not have permission to view this page
        </h2>
      ) : (
        currentPanelToShow
      )}
    </div>
  );
};

export default BranchesViewPanel;
